import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-9331ba30"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "equipment-selection"
};
const _hoisted_2 = {
  class: "operation-nav"
};
const _hoisted_3 = {
  class: "equipment-commission"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "commission-title"
}, "预计佣金：", -1));

const _hoisted_5 = {
  class: "commission-money"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/台", -1));

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 如暂不明确产品型号，最终以实际成交产品核算佣金 ");

import { getDeviceCategory, getDeviceCategoryMin, getDeviceMode, getDeviceCommission } from '@/api';
import { reactive, ref, onMounted } from 'vue';
import DeclareToast from '@/views/components/DeclareToast.vue';
// import { RecomFace } from '../type';
export default /*#__PURE__*/_defineComponent({
  __name: 'EquipmentSelection',
  emits: ['close', 'confirm'],

  setup(__props, {
    emit: emits
  }) {
    const equipment = reactive({
      equipmentName: '',
      equipmentSize: '',
      equipmentModel: ''
    });
    const equipmentMOde = ref();
    const CategoryId = ref(null);
    const CategorySizeId = ref(null);
    const CategoryMOdeId = ref(null);
    const commission = ref('--');
    const display = ref(false); // eslint-disable-next-line @typescript-eslint/no-explicit-any

    const columns = ref([// 第一列
    {
      values: [],
      defaultIndex: 0
    }, // 第二列
    {
      values: [],
      defaultIndex: 0
    }, // 第三列
    {
      values: [],
      defaultIndex: 0
    }, // 第三列
    {
      values: ['']
    }]);
    const customFieldName = {
      text: 'name'
    };
    onMounted(() => {
      apiDeviceCategory();
    }); // 请求设备大类

    const apiDeviceCategory = async () => {
      try {
        let res = await getDeviceCategory(null);
        const {
          code,
          data
        } = res;

        if (code === 200) {
          columns.value[0].values = data;

          if (!CategoryId.value) {
            CategoryId.value = columns.value[0].values[0].deviceCategoryId;
            equipment.equipmentName = columns.value[0].values[0].name;
            apiDeviceCategorySize(CategoryId.value);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }; // 请求设备大小


    const apiDeviceCategorySize = async deviceCategoryId => {
      try {
        const res = await getDeviceCategoryMin({
          deviceCategoryId
        });
        const {
          code,
          data
        } = res;

        if (code === 200) {
          columns.value[1].values = data;

          if (!CategorySizeId.value) {
            CategorySizeId.value = columns.value[1].values[0].deviceCategoryId;
            equipment.equipmentSize = columns.value[1].values[0].name;
            apiDeviceMode(CategorySizeId.value);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }; // 请求设备小类


    const apiDeviceMode = async deviceCategoryId => {
      try {
        const res = await getDeviceMode({
          deviceCategoryId
        });
        const {
          code,
          data
        } = res;

        if (code === 200) {
          columns.value[2].values = data;
          columns.value[2].values.forEach(item => {
            item.name = item.deviceMode;
          });

          if (!CategoryMOdeId.value) {
            CategoryMOdeId.value = columns.value[2].values[0].deviceId;
            equipment.equipmentModel = columns.value[2].values[0].name;
            apiDeviceCommission();
          }
        }
      } catch (error) {
        console.log(error);
      }
    }; // 计算佣金


    const apiDeviceCommission = async () => {
      try {
        display.value = true;

        if (CategorySizeId.value && CategoryMOdeId.value) {
          const res = await getDeviceCommission({
            deviceId: CategoryMOdeId.value,
            deviceNum: 1
          });
          commission.value = res.data;
        }
      } catch (error) {
        console.log(error);
      } finally {
        display.value = false;
      }
    };

    const onSubclass = (val, name) => {
      if (val !== CategoryId.value) {
        CategoryId.value = val;
        equipment.equipmentName = name;
        equipment.equipmentSize = '';
        equipment.equipmentModel = '';
        apiDeviceCategorySize(val);
        equipmentMOde.value = [];
        commission.value = '--';
      }
    };

    const onSubclassSize = (val, name) => {
      apiDeviceMode(val);

      if (val !== CategorySizeId.value) {
        CategorySizeId.value = val;
        equipment.equipmentSize = name;
        equipment.equipmentModel = '';
        commission.value = '--';
        apiDeviceMode(val);
      }
    };

    const onSubclassMode = (val, name) => {
      CategoryMOdeId.value = val;
      equipment.equipmentModel = name;
      apiDeviceCommission();
    }; // 确认事件


    const btnConfirm = () => {
      if (CategoryMOdeId.value && equipment.equipmentModel) {
        emits('confirm', equipment, CategoryMOdeId.value);
      } else {
        _Toast({
          message: '请选择设备',
          position: 'bottom'
        });
      }
    };

    const pickerChange = (val, index) => {
      switch (index) {
        case 0:
          CategoryId.value = null;
          CategorySizeId.value = null;
          CategoryMOdeId.value = null;
          onSubclass(val[index].deviceCategoryId, val[index].name);
          break;

        case 1:
          CategorySizeId.value = null;
          CategoryMOdeId.value = null;
          onSubclassSize(val[index].deviceCategoryId, val[index].name);
          break;

        default:
          CategoryMOdeId.value = null;
          onSubclassMode(val[index].deviceId, val[index].name);
          break;
      }
    };

    return (_ctx, _cache) => {
      const _component_van_notice_bar = _resolveComponent("van-notice-bar");

      const _component_van_picker = _resolveComponent("van-picker");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", {
        class: "operation-btn-cancel",
        onClick: _cache[0] || (_cache[0] = $event => emits('close'))
      }), _createElementVNode("span", {
        class: "operation-btn-confirm",
        onClick: btnConfirm
      })]), _createVNode(_component_van_picker, {
        title: "",
        columns: columns.value,
        "columns-field-names": customFieldName,
        onConfirm: btnConfirm,
        onCancel: _cache[1] || (_cache[1] = $event => emits('close')),
        onChange: pickerChange
      }, {
        "columns-top": _withCtx(() => [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", _hoisted_5, _toDisplayString(commission.value) + "元", 1), _hoisted_6]), _createElementVNode("div", null, [_createVNode(_component_van_notice_bar, {
          scrollable: "",
          color: "#FF1717",
          background: "#FFE6E6",
          "left-icon": "info-o"
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        })])]),
        _: 1
      }, 8, ["columns"])]), display.value ? (_openBlock(), _createBlock(DeclareToast, {
        key: 0,
        show: display.value
      }, null, 8, ["show"])) : _createCommentVNode("", true)], 64);
    };
  }

});